export const IMPORT_COLUMNS_WIDTH = {
  'Timesheet Approval Needed?': 300,
  'Timesheet Approver': 300,
  'Communication Method': 300,
  'Building Society Number ': 300,
  'Domestic Reverse Charge Applicable?': 400,
  'Emergency Contact Name': 300,
  'Emergency Contact Email': 300,
  'Emergency Contact Telephone': 300,
  'Emergency Contact Mobile': 300,
  'Included In Timesheet Rate': 300,
  'Reclaim App Levy Costs': 300,
  'Holiday Pay Opening Balance': 300,
  'Holiday Pay App Levy': 300,
  'Holiday Pay ER Pension': 300,
  'Expense Receipt Upload Mandatory': 300,
  'Expense Opening Balance': 300,
  'ER pension deduction method': 300,
  'EE pension deduction method': 300,
  'Building Society Number': 250,
  'Personal Verification Number': 300,
  'Employee Pension YTD': 250,
  'Employer Pension YTD': 250,
  'PG Student Loan YTD': 250,
  'Assignment Required?': 250,
  'Date on which classified on': 300,
  'Last Assessment Done On': 250,
  'Postponement End Date': 250,
  'Membership Start Date': 250,
  'Customer Success Manager': 250,
  'Emergency Contact Address 1': 300,
  'Emergency Contact Address 2': 300,
  'Emergency Contact Address 3': 300,
  'Emergency Contact City/Town': 300,
  'Emergency Contact County': 300,
  'Emergency Contact Post Code': 300,
  'Emergency Contact Country': 300,
  'Number of Weeks Worked': 250,
  'Document Expiry Date': 250,
  'Employee Reference Number': 300,
  'Employee PRSIable Gross YTD': 300,
  'Employer PRSIable Gross YTD': 300,
  'Payroll Approval Needed?': 300,
  'Emergency Contact EIR Code': 300,
  Message: 500,
};

export enum IMPORT_SCREEN_TYPE {
  AGENCY = 'AGENCY',
  EMPLOYEE = 'EMPLOYEE',
  PROSPECT = 'PROSPECT',
  TIMESHEET = 'TIMESHEET',
}

export enum AGENCY_UPLOAD_FILE_TYPE {
  PROSPECTS = 'PROSPECTS',
  SUBCONTRACTORS = 'SUBCONTRACTORS',
  TIMESHEETS = 'TIMESHEETS',
}

export const agencyUploadTypeOptions = [
  { label: 'Prospects', value: AGENCY_UPLOAD_FILE_TYPE.PROSPECTS },
  {
    label: 'Employees',
    value: AGENCY_UPLOAD_FILE_TYPE.SUBCONTRACTORS,
  },
  { label: 'Timesheets', value: AGENCY_UPLOAD_FILE_TYPE.TIMESHEETS },
];

export const viewUploadedFileByAgencyTitle = {
  [AGENCY_UPLOAD_FILE_TYPE.PROSPECTS]: 'Prospect Submitted',
  [AGENCY_UPLOAD_FILE_TYPE.TIMESHEETS]: 'Timesheet Submitted',
  [AGENCY_UPLOAD_FILE_TYPE.SUBCONTRACTORS]: 'Employee Submitted',
};

export const confirmCancelUploadFileLabel = {
  [AGENCY_UPLOAD_FILE_TYPE.PROSPECTS]: {
    title: 'Are you sure you want to cancel the prospect submitted file ?',
    content:
      'Once confirmed, the action cannot be undone and the prospect submitted files will be canceled.',
  },
  [AGENCY_UPLOAD_FILE_TYPE.TIMESHEETS]: {
    title: 'Are you sure you want to cancel the timesheet submitted file ?',
    content:
      'Once confirmed, the action cannot be undone and the timesheet submitted files will be canceled.',
  },
  [AGENCY_UPLOAD_FILE_TYPE.SUBCONTRACTORS]: {
    title: 'Are you sure you want to cancel the employee submitted file ?',
    content:
      'Once confirmed, the action cannot be undone and the employee submitted files will be canceled.',
  },
};

export const importTypeByAgencyUploadedFile = {
  [AGENCY_UPLOAD_FILE_TYPE.PROSPECTS]: IMPORT_SCREEN_TYPE.PROSPECT,
  [AGENCY_UPLOAD_FILE_TYPE.TIMESHEETS]: IMPORT_SCREEN_TYPE.TIMESHEET,
  [AGENCY_UPLOAD_FILE_TYPE.SUBCONTRACTORS]: IMPORT_SCREEN_TYPE.EMPLOYEE,
};

export const HMRC_GENDER_OPTIONS = {
  M: 'Male',
  F: 'Female',
  O: 'Other',
};

export const HMRC_PAY_FREQUENCY_OPTIONS = {
  W1: 'Weekly',
  W2: '2 Weekly',
  W4: '4 Weekly',
  M1: 'Monthly',
};
